<template>
    <section class="padding-vertical-content lightgray-content">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <h4 class="m-0 text-uppercase">{{ texto_producto_extra }}</h4>
                    <div class="float-right mr-4">
                        <b-button class="mr-2" @click="continuarProductoExtra(true)">Si, añadir</b-button>
                        <b-button class="mr-2" @click="continuarProductoExtra(false)">No, continuar</b-button>
                    </div>
                </div>
            </div>
        </div>
    </section>        
</template>

<script>
export default {
    props: ['texto_producto_extra'],
    methods: {
        continuarProductoExtra(add) {
            this.$emit('continuarProductoExtra', add);
        }
    }
}
</script>